import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import BookingApi from "../../API/Apis/BookingApi";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import { AppStandardButton } from "../../components/UI/AppButtons";
import { t } from "i18next";
import DefaultPage from "../../components/Layouts/DefaultPage";
// import { ThemeProvider } from "@mui/material/styles";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import theme from "../../config/MuiColorThemes";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";
import Pagination from "../../components/Layouts/ReservationsCard/Pagination";
import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { Search } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function CustomerDetailsList() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage] = React.useState(6);
  const dynamicTheme = null;
  const { t } = useTranslation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };

  const [totalCustomers, setTotalCustomers] = useState(0);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // const handleChangeRowsPerPage = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };
  const [customerList, setCustomerList] = useState([]);
  const [data, setCustomerDetails] = useState([]);
  useEffect(() => {
    const id: any = localStorage.getItem("userID");
    BookingApi.getCustomerDeatilsByUserid(
      id,
      page * rowsPerPage,
      rowsPerPage
    ).then((res) => {
      setTotalCustomers(res.data.total);
      setCustomerDetails(res.data.customerList);
      setCustomerList(res.data.customerList);
    });
  }, [page, rowsPerPage]);

  const isSmallScreen = window.innerWidth <= 768;
  const [userId] = useState(localStorage.getItem("userID"));
  const [, setReservedArea] = useState(false);

  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const handleSearchCustomer = () => {
    setSearchCustomer(searchInput); // this triggers the useEffect
  };
  useEffect(() => {
    if (searchCustomer != null && searchCustomer != "") {
      const searchTerm = searchCustomer
        .trim()
        .replace(/\s+/g, "")
        .toLowerCase();
      console.log("searchTerm", searchTerm);
      const filteredCustomer = data.filter((cus) => {
        const firstName = cus?.name?.toString().toLowerCase();
        const lastName = cus?.surname?.toString().toLowerCase();
        return (
          firstName.includes(searchTerm) ||
          lastName.includes(searchTerm) ||
          searchTerm.includes(firstName + lastName)
        );
      });
      setTotalCustomers(filteredCustomer.length);
      setCustomerList(filteredCustomer);
    } else {
      setTotalCustomers(data?.length);
      setCustomerList(data);
    }
  }, [searchCustomer]);

  useEffect(() => {
    if (userId != null && userId != "null" && userId != "") {
      setReservedArea(true);
    } else {
      setReservedArea(false);
    }
  }, [userId]);

  return (
    <ThemeProvider theme={dynamicTheme || theme}>
      <div>
        <>
          <div
            style={{
              color: "white",
              display: "none",
            }}
          >
            <CollapsibleNavbar
              isDrawerOpen={isDrawerOpen}
              toggleDrawer={toggleDrawer}
            />
          </div>
        </>
        <div className="flex">
          {!isSmallScreen && (
            <div className="!w-780" style={{ width: "363px" }}>
              <BookingDetalisListSideNavigation />
            </div>
          )}
          <div className="w-full rounded-sm pt-12">
            <div
              className="text-[#333] max-w-screen-xl m-auto"
              style={{
                paddingLeft: "1rem",
                paddingRight: "1rem",
                paddingTop: "16px",
              }}
            >
              <div className="flex justify-between items-center whitespace-nowrap">
                <div>
                  <p
                    className="font-medium leading-snug"
                    style={{
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      fontSize: isSmallScreen ? "24px" : "36px",
                    }}
                  >
                    {t("Customer Details")}{" "}
                    <span className="text-[#838181] text-[13px]">
                      ({totalCustomers})
                    </span>
                  </p>
                  <p
                    className="text-[#838181] text-[16px]"
                    style={{
                      fontFamily: "MBCorpoSText-CondLight-Web",
                      marginTop: "0px",
                      fontSize: isSmallScreen ? "12px" : "",
                    }}
                  >
                    {t("Here is your Customer Detail list.")}
                  </p>
                </div>
                <div className={"flex flex-row"}></div>
                <div className={"flex flex-row"}></div>
                <div className={"flex flex-row"}></div>
                <div
                  className="flex flex-wrap flex-row"
                  style={{
                    marginLeft: isSmallScreen ? "0px" : "35%",
                    fontFamily: "MBCorpoSTitle-Bold-Web-new",
                  }}
                ></div>
                {!isSmallScreen && (
                  <TextField
                    variant="outlined"
                    className="mr-4"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    placeholder={t("Search customer")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Search
                            onClick={handleSearchCustomer}
                            style={{
                              cursor: "pointer",
                              color: "#333",
                              height: "16px",
                            }}
                          />
                        </InputAdornment>
                      ),
                      style: {
                        height: "40px",
                        borderRadius: "10px",
                        paddingRight: "5px",
                      },
                    }}
                  />
                )}
                <div className="flex items-center">
                  <AppStandardButton
                    href="/"
                    className={"ml-4"}
                    variant="contained"
                    style={{
                      width: isSmallScreen ? "150px" : "150px",
                      backgroundColor: "primary",
                      borderRadius: "5px",
                      fontFamily: "MBCorpoSText-Bold-Web",
                    }}
                  >
                    <span
                      className="normal-case"
                      style={{
                        fontFamily: "MBCorpoSText-Bold-Web-new",
                        fontSize: isSmallScreen ? "12px" : "16px",
                      }}
                    >
                      {t("Book a Car")}
                    </span>
                  </AppStandardButton>
                </div>
              </div>
              {isSmallScreen && (
                <div
                  className="text-[#333] max-w-screen-xl m-auto"
                  style={{
                    marginTop: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    placeholder={t("Search")}
                    variant="outlined"
                    className="w-full mr-4"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Search
                            onClick={handleSearchCustomer}
                            style={{
                              cursor: "pointer",
                              color: "#333",
                              height: "16px",
                            }}
                          />
                        </InputAdornment>
                      ),
                      style: {
                        height: "31px",
                        maxWidth: "600px",
                        borderRadius: "3px",
                        paddingRight: "15px",
                        backgroundColor: "#f7f7f7",
                        border: "1px solid #ddd",
                        fontSize: "16px",
                        color: "#666",
                      },
                    }}
                  />
                </div>
              )}
            </div>

            {!isSmallScreen &&
              (!data || data.length === 0 ? (
                <DefaultPage
                  message={t(
                    "You have not created any booking yet. To create a new booking, please click on the Book a car button."
                  )}
                />
              ) : (
                <>
                  <TableContainer className="!shadow-grey-400 !rounded-2xl !border-solid !border-3 p-4">
                    <Table
                      className="!shadow-2xl rounded-2xl !border-solid !border-2 !border-grey-400"
                      aria-label="simple table"
                      stickyHeader
                    >
                      <TableHead
                        className="!bg-[primary] rounded-2xl"
                        style={{
                          fontFamily: "MBCorpoSText-CondLight-Web",
                          backgroundColor: "#BDBDBD",
                        }}
                      >
                        <TableRow className="!bg-[primary]">
                          <TableCell
                            className="!text-[15px] rounded-tl-2xl"
                            style={{
                              backgroundColor: "#BDBDBD",
                              color: "#000000",
                              fontFamily:
                                "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                            }}
                          >
                            {t("Full name")}
                          </TableCell>
                          <TableCell
                            className="!text-[15px]"
                            style={{
                              backgroundColor: "#BDBDBD",
                              color: "#000000",
                              fontFamily:
                                "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                            }}
                          >
                            {t("Email")}
                          </TableCell>
                          <TableCell
                            className="!text-[15px]"
                            style={{
                              backgroundColor: "#BDBDBD",
                              color: "#000000",
                              fontFamily:
                                "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                            }}
                          >
                            {t("Phone")}
                          </TableCell>
                          <TableCell
                            className="!text-[15px] rounded-tr-2xl"
                            style={{
                              backgroundColor: "#BDBDBD",
                              color: "#000000",
                              fontFamily:
                                "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                            }}
                          >
                            {t("Company Name")}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {customerList.map((e, i) => (
                          <TableRow key={i}>
                            <TableCell
                              className="!text-[12px] rounded-bl-2xl"
                              component="th"
                              scope="e"
                              style={{
                                fontFamily:
                                  "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                              }}
                            >
                              <ul>
                                <li
                                  style={{
                                    fontFamily:
                                      "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                                  }}
                                >
                                  {e.name || ""} {e.surname}
                                </li>
                              </ul>
                            </TableCell>
                            <TableCell
                              className="!text-[12px]"
                              style={{
                                fontFamily:
                                  "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                              }}
                            >
                              {e.email || ""}
                            </TableCell>
                            <TableCell
                              className="!text-[12px]"
                              style={{
                                fontFamily:
                                  "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                              }}
                            >
                              {e.mobileNumber || ""}
                            </TableCell>
                            <TableCell
                              className="!text-[12px] rounded-br-2xl"
                              style={{
                                fontFamily:
                                  "MBCorpoSTitle-CondRegular-Web-STitle-CondRegular",
                              }}
                            >
                              {e.companyName || ""}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Pagination
                      count={totalCustomers}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      onPageChange={handleChangePage}
                      //onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </>
              ))}
            {isSmallScreen &&
              (!data || data.length === 0 ? (
                <DefaultPage
                  message={t(
                    "You have not created any booking yet. To create a new booking, please click on the Book a car button."
                  )}
                />
              ) : (
                <>
                  <Grid container spacing={2}>
                    {customerList.map((e, i) => (
                      <Grid item xs={12} sm={6} md={4} key={i}>
                        <Card
                          className="!shadow-2xl rounded-2xl !border-solid !border-2 !border-grey-400 ml-5 whitespace-nowrap"
                          style={{
                            marginRight: "14px",
                            marginLeft: "14px",
                            borderRadius: "8px",
                          }}
                        >
                          <CardHeader
                            title={`${e.name || ""} ${e.surname || ""}`}
                            style={{
                              color: "#000000",
                              backgroundColor: "#BDBDBD",
                              fontFamily: "MBCorpoSText-Regular-Web-new",
                              height: "30px",
                              padding: "8px 16px",
                              lineHeight: "1.5",
                            }}
                            titleTypographyProps={{
                              style: {
                                color: "#000000",
                                fontSize: "14px",
                              },
                            }}
                          />
                          <CardContent
                            style={{
                              padding: "8px 16px",
                            }}
                          >
                            <Typography
                              className="!text-[15px]"
                              gutterBottom
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: "14px",
                                fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                              }}
                            >
                              <span>{t("First Name")}</span>
                              <span>{e.name}</span>
                            </Typography>
                            <hr />
                            <Typography
                              className="!text-[15px]"
                              gutterBottom
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: "14px",
                                fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                                marginTop: "4px",
                              }}
                            >
                              <span>{t("Last Name")}</span>
                              <span>{e.surname}</span>
                            </Typography>
                            <hr />
                            <Typography
                              className="!text-[15px]"
                              gutterBottom
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: "14px",
                                fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                                marginTop: "4px",
                              }}
                            >
                              <span>{t("Email Address")}</span>
                              <span style={{ color: "#7B7B7B" }}>
                                {e.email || ""}
                              </span>
                            </Typography>
                            <hr />
                            <Typography
                              className="!text-[15px]"
                              gutterBottom
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: "14px",
                                fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                                marginTop: "4px",
                              }}
                            >
                              <span>{t("Phone Number")}</span>
                              <span>{e.mobileNumber || ""}</span>
                            </Typography>
                            <hr />
                            <Typography
                              className="!text-[15px]"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: "14px",
                                fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                                marginTop: "4px",
                              }}
                            >
                              <span>{t("Company Name")}</span>
                              <span>
                                {e.isPhysicalPerson === "true"
                                  ? ""
                                  : e.companyName || ""}
                              </span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Pagination
                      count={totalCustomers}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      onPageChange={handleChangePage}
                    />
                  </div>
                </>
              ))}
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
